export default "__VITE_ASSET__0053e771__"